module.exports = __webpack_public_path__ + "static/media/hero-image.6b7eecee.png";